import { render, staticRenderFns } from "./SelectProductSection.vue?vue&type=template&id=5e23797b&"
import script from "./SelectProductSection.vue?vue&type=script&lang=js&"
export * from "./SelectProductSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports